import React from 'react';
import Administration from './Administration';

const AdminContainer = () => {
    return (
        <Administration/>
    )
}

export default AdminContainer;